<template>
  <footer class="c-footer">
    <b-row class="c-footer-content align-items-center justify-content-center">
      <b-col sm="12" md="6">
        <router-link to="/iso-quality">
          <img src="@/assets/images/isoqualidade.png" alt="isoquality" />
        </router-link>
      </b-col>
      <b-col sm="12" md="6" class="wrap-contact-info">
        <p style="text-align:center">{{ content.general.endereco_rua }}</p>
        <p style="text-align:center">{{ content.general.endereco_cidade }}</p>
        <p style="text-align:center">{{ content.general.telefone_principal }}</p>
        <p style="text-align:center">{{ content.general.fax_principal }}</p>
        <a href="mailto:sibrol@sibrol.com.br">{{ content.general.email }}</a>
      </b-col>
    </b-row>
  </footer>
</template>

<script>
// Json Content
import json from "../assets/content.json";

export default {
  name: "Footer",
  data() {
    return {
      content: json,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_standard.scss";

.c-footer {
  background-color: $primary-light-background;
  padding: 30px 0;
  text-align: center;

  .c-footer-content {
    .wrap-contact-info {
      margin-top: 20px;
    }
  }

  p {
    margin-bottom: 0;
  }
}
</style>
